import styled from 'styled-components';

// Single scroll context for the frame-level inspector view (Comments only).
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	overflow-y: auto;
`;
